import Button from '@/common/components/base/button/Button';
import Typography from '@/common/components/base/typography/Typography';
import ArrowUpIcon from '@/modules/Education/assets/icons/arrow-up.svg?react';
import { useEffect, useState } from 'react';
import { css } from 'styled-system/css';
import { Flex } from 'styled-system/jsx';
import { GetEducationDetailQueryResponseType } from '../../queries/getEducationDetail/getEducationDetailQuery.type';
import HtmlContent from './HtmlContent';

export default function EducationContent({
  data,
}: {
  data: GetEducationDetailQueryResponseType;
}) {
  const [showScrollTop, setShowScrollTop] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const onScroll = () => setShowScrollTop(window.scrollY > 300);
    window.addEventListener('scroll', onScroll);
    onScroll();

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Flex flexDirection="column" pt={24}>
      <Typography color="black" textStyle="h1">
        {data?.title}
      </Typography>
      <Typography color="black-1" textStyle="b2" pt={8}>
        {data?.abstraction}
      </Typography>

      <Flex gap={4} flexWrap="wrap" pt={12}>
        {data?.categories?.map((item) => (
          <Typography
            key={item?.id}
            textStyle="b2"
            color="black-2"
            bgColor="gray-2"
            px={6}
            py={1}
            borderRadius={8}
          >
            {item?.title}
          </Typography>
        ))}
      </Flex>

      {data?.type === 'text' && (
        <>
          <HtmlContent html={data?.text} />

          {showScrollTop && (
            <Button
              className={css({
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                width: '50%',
                bgColor: 'purple-6',
                borderRadius: '8px',
                padding: '7px 16px',
                marginBottom: '24px',
                alignSelf: 'center',
              })}
              onClick={scrollToTop}
            >
              <Typography color="purple-primary" whiteSpace="nowrap">
                بازگشت به بالا
              </Typography>

              <ArrowUpIcon />
            </Button>
          )}
        </>
      )}
    </Flex>
  );
}
